module.exports = __webpack_public_path__ + "img/green-counter-th.73e67384.png";